import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  image?: string;
  rating?: number;
}
export function TestimonialCard({
  quote,
  author,
  image,
  rating = 5
}: TestimonialCardProps) {
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<Star key={`full-${i}`} className="w-4 h-4 text-[#FDB022]" fill="#FDB022" strokeWidth={1.5} data-id="element-266" />);
    }
    // Half star
    if (hasHalfStar) {
      stars.push(<div key="half" className="relative w-4 h-4" data-id="element-267">
          <Star className="absolute w-4 h-4 text-[#FDB022]" fill="none" strokeWidth={1.5} data-id="element-268" />
          <div className="absolute overflow-hidden w-2 h-4" data-id="element-269">
            <Star className="w-4 h-4 text-[#FDB022]" fill="#FDB022" strokeWidth={1.5} data-id="element-270" />
          </div>
        </div>);
    }
    return stars;
  };
  return <div className="bg-white rounded-xl p-6 shadow-soft border border-[#E8905C]/20" data-id="element-271">
      {image && <div className="mb-4 flex justify-center" data-id="element-272">
          <img src={image} alt={author} className="w-16 h-16 rounded-full object-cover border-2 border-[#E8905C]/30" data-id="element-273" />
        </div>}

      {/* Star Rating */}
      <div className="flex justify-center gap-1 mb-4" data-id="element-274">{renderStars()}</div>

      <p className="text-[#3E4A55] italic mb-4 leading-relaxed" data-id="element-275">
        &quot;{quote}&quot;
      </p>
      <p className="text-[#1C2A3A] font-semibold text-center" data-id="element-276">— {author}</p>
    </div>;
}